import React from "react";
import ProductTypeEditView from "domains/productType/components/ProductTypeEditView";

const ProductTypeEditPage: React.FC = () => {
  return <ProductTypeEditView />;
};

export default ProductTypeEditPage;
